module.exports = __webpack_public_path__ + "img/login_logo.ce32fa3e.png";